/* @flow weak */
import _ from 'lodash';
import isEmail from 'lib/isEmail';
import isPhone from 'lib/isPhone';
import { stripFormattingAndLeading1 } from 'lib/phoneNumbers';

const VALID = 'VALID';
const INVALID = 'INVALID';
const UNKNOWN = 'UNKNOWN';

const newToken = recipient => {
  if (isEmail(recipient)) {
    return { value: recipient, address: 'email://' + recipient, status: UNKNOWN };
  } else if (isPhone(recipient)) {
    return { value: recipient, address: 'sms://' + recipient, status: UNKNOWN };
  } else {
    return { value: recipient, address: null, status: INVALID };
  }
};

const parse = (input, ignoreTrailing) => {
  const shouldIgnoreTrailing = ignoreTrailing !== false;

  const recipients = input.split(/[;,\n]+/);
  const results = [];

  if (shouldIgnoreTrailing && recipients.length <= 1) {
    return results;
  }

  _.each(recipients, function(recipient) {
    const trimmedRecipient = recipient.trim();
    if (trimmedRecipient.length > 1) {
      results.push(newToken(trimmedRecipient.trim()));
    }
  });

  return results;
};

// The first argument here MUST be in the email:// or sms:// format that api returns for
// many addresses, while the possible match is user inputted
const addressesMatch = (apiFormattedAddress: string, possibleMatch: string): boolean => {
  const isSms = apiFormattedAddress.startsWith('sms://');

  // Removes sms://+1 or email:// from the address string
  const address = apiFormattedAddress.replace(/.*\/\/(\+1)*/, '');

  // We strip the +1 out of numbers above since most users enter numbers without them.
  // Since there is a small chance of users entering #s with +1, strip them out here as well.
  // Also remove any other characters (parens, dashes, etc) since the backend strips those
  const normalizedPossibleMatch = isSms ? stripFormattingAndLeading1(possibleMatch) : possibleMatch;

  return address === normalizedPossibleMatch;
};

export default {
  VALID,
  INVALID,
  UNKNOWN,
  parse,
  newToken,
  addressesMatch,
};
